import gql from "graphql-tag";

export const profileQuery = gql`
  query profileQuery($brokerId: String!,$token:String!) {
    BrokerProfile(brokerId:$brokerId,token:$token){
      profile
    }
  }
`;


export const assistantProfileQuery = gql`
  query assistantProfile($userId: String!,$token:String!) {
    AssistantProfile(userId:$userId,token:$token){
      profile
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/profileQuery.js